import { Component } from '@angular/core';

@Component({
    selector: 'toaster',
    templateUrl: './toaster.component.html',
    styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent {
    message: string;
    isSuccess: boolean = false;
    isError: boolean = false;

    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/toaster/toaster.component.ts